import React, { useCallback } from 'react'
import { getConfig } from '../../../../config'
import { InstallType } from '../../../../lib/hooks/install-eligibility'
import {
  BrowserSpecificExtensionInstallButtonBase,
  BrowserSpecificExtensionInstallButtonProps,
} from './browser-specific'

const { downloadUrl } = getConfig().products.extension.safari

export type SafariInstallButtonProps = BrowserSpecificExtensionInstallButtonProps

export const SafariInstallButton: React.FC<SafariInstallButtonProps> = (props) => {
  const handleInstall = useCallback(() => {
    window.open(downloadUrl, '_blank')
  }, [])

  return (
    <BrowserSpecificExtensionInstallButtonBase
      {...props}
      installUrl={downloadUrl}
      onClick={handleInstall}
      install={InstallType.Safari}
    />
  )
}
